module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant5.a0f16c5f.png";